module.exports = __webpack_public_path__ + "img/Slika6_2021.c35a3431.png";